module.exports = "/_next/static/images/d21a5d3abe7f08197e2fdc863b9c9a28-custom-pencil.svg.webp";